import { useEffect, useState } from 'preact/hooks';

type Status = { id: string; online: boolean; players: number | null };
const worlds = [
  { id: 'main', number: 1, name: 'Monument', type: '1× · No botting', href: '/main/play/?world=main', description: 'Custom dungeons, housing, world PK and upgradable skills. No botting or AFK attacks.' },
  { id: 'legacy', number: 2, name: 'Legacy', type: '2.5× · Bot-friendly', href: '/play/?world=legacy', description: 'Daily world spawns, housing, PK, skill mastery and a built-in bot.' },
];

export function WorldPicker() {
  const [status, setStatus] = useState<Status[]>([]);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let stopped = false;
    const controller = new AbortController();
    const refresh = async () => {
      try {
        const response = await fetch('/worlds/status.json', { cache: 'no-store', signal: controller.signal });
        if (!response.ok) throw new Error('World status unavailable');
        const data = await response.json();
        if (!Array.isArray(data.worlds)) throw new Error('Invalid world status');
        if (!stopped) { setStatus(data.worlds); setFailed(false); }
      } catch { if (!stopped) { setStatus([]); setFailed(true); } }
    };
    void refresh();
    const interval = setInterval(refresh, 15000);
    return () => { stopped = true; controller.abort(); clearInterval(interval); };
  }, []);
  return <div class='flex h-full w-full items-center justify-center overflow-y-auto p-4'>
    <section class='card w-full max-w-3xl border border-base-300 bg-base-100 shadow-xl' aria-label='World selection'>
      <div class='card-body gap-5 p-5 sm:p-8'>
        <div><p class='text-sm font-semibold text-primary'>EOWorld</p><h1 class='text-2xl font-bold'>Choose your world</h1>
          <p class='mt-2 text-sm opacity-75'>Separate worlds. Separate adventures. Pick where you want to play.</p></div>
        <div class='flex flex-col gap-3'>
          {worlds.map(world => {
            const state = status.find(s => s.id === world.id);
            const unavailable = state?.online === false;
            return <a key={world.id} href={unavailable ? undefined : world.href} aria-disabled={unavailable}
              class={`flex flex-wrap items-center gap-4 rounded-lg border border-base-300 bg-base-200 p-4 ${unavailable ? 'opacity-60' : 'hover:border-primary focus:outline-2 focus:outline-primary'}`}>
              <span class='text-lg font-bold text-primary'>{world.number.toString().padStart(2, '0')}</span>
              <div class='min-w-0 flex-1'><div class='flex flex-wrap items-center gap-2'><h2 class='text-lg font-bold'>{world.name}</h2><span class='badge badge-outline badge-sm'>{world.type}</span></div>
                <p class='mt-1 text-sm opacity-75'>{world.description}</p></div>
              <div class='text-right text-sm'><p class={state?.online ? 'text-success' : ''}>{state ? state.online ? 'Online' : 'Offline' : failed ? 'Status unavailable' : 'Checking…'}</p>
                <p class='opacity-70'>{state?.online && state.players !== null ? `${state.players} players` : '—'}</p></div>
              <span class='text-primary' aria-hidden='true'>→</span>
            </a>;
          })}
        </div>
        <p class='text-sm opacity-75'>Each world has its own characters, items, guilds and progress.</p>
        <a href='/' class='link self-start text-sm'>Back to website</a>
      </div>
    </section>
  </div>;
}
